import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { withStyles } from '@material-ui/core/styles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const styles = () => ({
  editorWrapper: {
    padding: '20px 20px 20px',
  },
  editorContent: {
    minHeight: '50vh',
    border: '1px solid #C3C3C3',
  },
  toolbarContent: {
    border: '1px solid #C3C3C3',
  },
});

class NoteEditorComponent extends React.Component {

  render() {
    const { classes, handleChange } = this.props;
    return (
        <Editor
          editorState={this.props.editorState}
          onEditorStateChange={handleChange}
          wrapperClassName={classes.editorWrapper}
          editorClassName={classes.editorContent}
          toolbarClassName={classes.toolbarContent}
        />
    );
  }
}

export default withStyles(styles)(NoteEditorComponent);
